import { sample } from 'effector';
import { changeBinsEv, changeTableEv } from './events.js';
import { $bins, $ochvData, $tableControl } from './stores.js';
import { getOCHVBinsFx } from './effects.js';

$tableControl.on(changeTableEv, (state, payload) => {
  return {
    ...state,
    ...payload,
  };
});

sample({
  source: $bins,
  clock: changeBinsEv,
  fn: (source, clock) => {
    if (source.includes(clock)) {
      return source;
    }
    if (Array.isArray(clock)) {
      return clock;
    }
    return [...source, clock];
  },
  target: $bins,
});

sample({
  source: $tableControl,
  clock: $bins.updates,
  fn: (source, clock) => {
    return {
      bins: clock,
      table: source,
    };
  },
  target: getOCHVBinsFx,
});

sample({
  source: $bins,
  clock: $tableControl.updates,
  fn: (source, clock) => {
    return {
      bins: source,
      table: clock,
    };
  },
  target: getOCHVBinsFx,
});

sample({
  clock: getOCHVBinsFx.doneData,
  target: $ochvData,
});
